import type { InputRef } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { SearchInput } from '@tools/ui/dime';
import useT from '@tools/ui-hooks/useT';
import { parseQuickAccessQuery } from '../../../utils/parse-quick-access-query';

export const QuickAccess: React.FC = () => {
  const { t } = useT();
  const history = useHistory();
  const inputRef = useRef<InputRef>(null);
  const [query, setQuery] = useState('');

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSearch = (value: string) => {
    setQuery('');
    parseQuickAccessQuery(value, history);
  };

  return (
    <Container onMouseDown={(event) => event.stopPropagation()}>
      <SearchInput
        ref={inputRef}
        placeholder={t('reco.quickAccessPlaceholder')}
        value={query}
        onChange={(event) => setQuery(event.target.value)}
        onSearch={handleSearch}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 320px;

  && .ant-input-search {
    margin-bottom: 0;
  }
`;
